import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const referencesManifest: FeatureManifest = {
  id: 'english-language-references',
  path: 'english-knowledge/references/*',
  navPath: '/english-knowledge/references',
  label: 'Tham khảo',
  description: 'Nguồn tham khảo cho khung tiêu chuẩn',
  navigationGroup: { id: 'english-skills', label: 'Tiêu chuẩn' },
  load: () => import('./entry'),
}
